import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authService.authenticated().pipe(
      map(isAuthenticated => {
        if (!isAuthenticated) {
          return false;
        }
        const returnUrl = this.authService.consumeReturnUrl();
        if (!returnUrl || sameRoute(returnUrl, state.url)) {
          return true;
        }
        return this.router.parseUrl(returnUrl);
      })
    );
  }
}

function sameRoute(returnUrl: string, currentUrl: string): boolean {
  return canonical(returnUrl) === canonical(currentUrl);
}

function canonical(url: string): string {
  const hashAt = url.indexOf('#');
  const hash = hashAt >= 0 ? url.slice(hashAt) : '';
  const withoutHash = hashAt >= 0 ? url.slice(0, hashAt) : url;
  const queryAt = withoutHash.indexOf('?');
  const path = queryAt >= 0 ? withoutHash.slice(0, queryAt) : withoutHash;
  const search = queryAt >= 0 ? withoutHash.slice(queryAt) : '';
  const trimmed = path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
  return `${trimmed}${search}${hash}`;
}
